<template>
  <div>
    <div
      v-if="showing"
      class="fixed pt-24 pb-10 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-20"
    >
      <div
        class="mx-2 w-full max-w-xl max-h-full bg-white shadow-lg rounded-lg overflow-auto px-4"
      >
        <div class="flex flex-col sticky top-0 bg-white pt-5 z-50">
          <div class="absolute right-0">
            <button
              aria-label="close"
              class="text-xl text-gray-500"
              @click.prevent="close"
            >
              ×
            </button>
          </div>
        </div>

        <div
          class="flex w-full justify-center items-center pb-3"
        >
          <div class="w-1/3 pb-2 text-left flex flex-wrap">
            <ShareNetwork
              network="facebook"
              :url="replaceURL()"
              :title="levantamientoInfo.nombre"
              :description="levantamientoInfo.description"
              hashtags="miapptsil"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 48 48"
                width="48px"
                height="48px"
              >
                <path
                  fill="#039be5"
                  d="M24 5A19 19 0 1 0 24 43A19 19 0 1 0 24 5Z"
                />
                <path
                  fill="#fff"
                  d="M26.572,29.036h4.917l0.772-4.995h-5.69v-2.73c0-2.075,0.678-3.915,2.619-3.915h3.119v-4.359c-0.548-0.074-1.707-0.236-3.897-0.236c-4.573,0-7.254,2.415-7.254,7.917v3.323h-4.701v4.995h4.701v13.729C22.089,42.905,23.032,43,24,43c0.875,0,1.729-0.08,2.572-0.194V29.036z"
                />
              </svg>
            </ShareNetwork>
            <ShareNetwork
              network="twitter"
              :url="replaceURL()"
              :title="levantamientoInfo.nombre"
              :description="levantamientoInfo.description"
              hashtags="miapptsil"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 48 48"
                width="48px"
                height="48px"
              >
                <path
                  fill="#03A9F4"
                  d="M42,12.429c-1.323,0.586-2.746,0.977-4.247,1.162c1.526-0.906,2.7-2.351,3.251-4.058c-1.428,0.837-3.01,1.452-4.693,1.776C34.967,9.884,33.05,9,30.926,9c-4.08,0-7.387,3.278-7.387,7.32c0,0.572,0.067,1.129,0.193,1.67c-6.138-0.308-11.582-3.226-15.224-7.654c-0.64,1.082-1,2.349-1,3.686c0,2.541,1.301,4.778,3.285,6.096c-1.211-0.037-2.351-0.374-3.349-0.914c0,0.022,0,0.055,0,0.086c0,3.551,2.547,6.508,5.923,7.181c-0.617,0.169-1.269,0.263-1.941,0.263c-0.477,0-0.942-0.054-1.392-0.135c0.94,2.902,3.667,5.023,6.898,5.086c-2.528,1.96-5.712,3.134-9.174,3.134c-0.598,0-1.183-0.034-1.761-0.104C9.268,36.786,13.152,38,17.321,38c13.585,0,21.017-11.156,21.017-20.834c0-0.317-0.01-0.633-0.025-0.945C39.763,15.197,41.013,13.905,42,12.429"
                />
              </svg>
            </ShareNetwork>
            <ShareNetwork
              network="whatsapp"
              :url="replaceURL()"
              :title="levantamientoInfo.nombre"
              :description="levantamientoInfo.description"
              hashtags="miapptsil"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 48 48"
                width="48px"
                height="48px"
                fill-rule="evenodd"
                clip-rule="evenodd"
              >
                <path
                  fill="#fff"
                  d="M4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98c-0.001,0,0,0,0,0h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303z"
                />
                <path
                  fill="#fff"
                  d="M4.868,43.803c-0.132,0-0.26-0.052-0.355-0.148c-0.125-0.127-0.174-0.312-0.127-0.483l2.639-9.636c-1.636-2.906-2.499-6.206-2.497-9.556C4.532,13.238,13.273,4.5,24.014,4.5c5.21,0.002,10.105,2.031,13.784,5.713c3.679,3.683,5.704,8.577,5.702,13.781c-0.004,10.741-8.746,19.48-19.486,19.48c-3.189-0.001-6.344-0.788-9.144-2.277l-9.875,2.589C4.953,43.798,4.911,43.803,4.868,43.803z"
                />
                <path
                  fill="#cfd8dc"
                  d="M24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,4C24.014,4,24.014,4,24.014,4C12.998,4,4.032,12.962,4.027,23.979c-0.001,3.367,0.849,6.685,2.461,9.622l-2.585,9.439c-0.094,0.345,0.002,0.713,0.254,0.967c0.19,0.192,0.447,0.297,0.711,0.297c0.085,0,0.17-0.011,0.254-0.033l9.687-2.54c2.828,1.468,5.998,2.243,9.197,2.244c11.024,0,19.99-8.963,19.995-19.98c0.002-5.339-2.075-10.359-5.848-14.135C34.378,6.083,29.357,4.002,24.014,4L24.014,4z"
                />
                <path
                  fill="#40c351"
                  d="M35.176,12.832c-2.98-2.982-6.941-4.625-11.157-4.626c-8.704,0-15.783,7.076-15.787,15.774c-0.001,2.981,0.833,5.883,2.413,8.396l0.376,0.597l-1.595,5.821l5.973-1.566l0.577,0.342c2.422,1.438,5.2,2.198,8.032,2.199h0.006c8.698,0,15.777-7.077,15.78-15.776C39.795,19.778,38.156,15.814,35.176,12.832z"
                />
                <path
                  fill="#fff"
                  fill-rule="evenodd"
                  d="M19.268,16.045c-0.355-0.79-0.729-0.806-1.068-0.82c-0.277-0.012-0.593-0.011-0.909-0.011c-0.316,0-0.83,0.119-1.265,0.594c-0.435,0.475-1.661,1.622-1.661,3.956c0,2.334,1.7,4.59,1.937,4.906c0.237,0.316,3.282,5.259,8.104,7.161c4.007,1.58,4.823,1.266,5.693,1.187c0.87-0.079,2.807-1.147,3.202-2.255c0.395-1.108,0.395-2.057,0.277-2.255c-0.119-0.198-0.435-0.316-0.909-0.554s-2.807-1.385-3.242-1.543c-0.435-0.158-0.751-0.237-1.068,0.238c-0.316,0.474-1.225,1.543-1.502,1.859c-0.277,0.317-0.554,0.357-1.028,0.119c-0.474-0.238-2.002-0.738-3.815-2.354c-1.41-1.257-2.362-2.81-2.639-3.285c-0.277-0.474-0.03-0.731,0.208-0.968c0.213-0.213,0.474-0.554,0.712-0.831c0.237-0.277,0.316-0.475,0.474-0.791c0.158-0.317,0.079-0.594-0.04-0.831C20.612,19.329,19.69,16.983,19.268,16.045z"
                  clip-rule="evenodd"
                />
              </svg>
            </ShareNetwork>
          </div>
        </div>

        <div class="flex flex-wrap">
        </div>
      </div>
    </div>

    <alert-dialog :showing="showingSuccess">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          Levantamiento guardado correctamente
        </div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-green-400"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full" v-if="answers.length === 0">
        <span class="text-sm tracking-wide text-purple-500"
          >Es necesario llenar la ficha del levantamiento</span
        >
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="close()"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>
    <alert-dialog :showing="showingError">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Ha ocurrido un error.</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-cdmx-red"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingError = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>
  </div>
</template>
<script>
import config from "../../vue.config.js";
import AlertDialog from "./AlertDialog";
import moment from "moment";

export default {
  name: "compartir-shared",
  data() {
    return {
      fileMimeType: null,
      categorySelected: null,
      categories: [],
      subcategorySelected: null,
      subcategories: [],
      nameLevantamiento: null,
      showCategoriesView: false,
      showMultimediaView: false,
      showFormView: true,
      questions: [],
      answers: [],
      inputFilePlaceholder: "Sin archivos seleccionados",
      levantamientoMediaUrl: null,
      imageSelected: false,
      videoSelected: false,
      currentQuestions: [],
      user_id: localStorage.getItem("user_id"),
      category_id: localStorage.getItem("category"),
      errors: {
        selectCategory: false,
        selectSubcategory: false,
        name: false,
        file_extension: false,
        codeError: "Ha ocurrido un error",
      },
      showingSuccess: false,
      showingError: false,
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken"),
        },
      },
      mediaArray: [],
      currentMediaIndex: 0,
    };
  },
  props: {
    showing: {
      required: true,
      type: Boolean,
    },
    levantamientoInfo: {
      required: true,
      type: Object,
    },
  },
  watch: {
    showing(value) {
      console.log(value);
      if (value) {
        console.log(this.levantamientoInfo);
        //this.fetchQuestions();
        this.currentQuestions = [];
        this.fetchAnswers();
        if (this.levantamientoInfo.ubicacion_sensible) {
          this.mediaArray = JSON.parse(this.levantamientoInfo.media_array);
        }
        return document.querySelector("body").classList.add("overflow-hidden");
      }

      document.querySelector("body").classList.remove("overflow-hidden");
    },
  },
  mounted() {
    console.log("mounted");
    this.fetchCategories();
  },
  components: {
    AlertDialog,
  },
  methods: {
    reset: function () {
      this.fileMimeType = null;
      this.categorySelected = null;
      this.subcategorySelected = null;
      this.subcategories = [];
      this.nameLevantamiento = null;
      this.showCategoriesView = false;
      this.showMultimediaView = false;
      this.showFormView = true;
      this.questions = [];
      this.answers = [];
      this.imageSelected = false;
      this.videoSelected = false;
      this.inputFilePlaceholder = "Sin archivos seleccionados";
      this.errors = {
        selectCategory: false,
        selectSubcategory: false,
        name: false,
        file_extension: false,
        codeError: "Ha ocurrido un error",
      };
      this.showingSuccess = false;
      this.showingError = false;
      this.mediaArray = [];
      this.currentMediaIndex = 0;
    },
    close() {
      this.reset();
      this.$emit("close");
    },
    fetchCategories() {
      console.log("fetchCategories");
      this.axios
        .get("../apidev/categories/catprinc/getMainCategories", this.config)
        .then((response) => {
          this.categories = response.data.categorias;
        })
        .catch((error) => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },
    fetchSubcategories() {
      this.axios
        .post(
          "../apidev/categories/subcategorias/getSubcategories",
          {
            id_maincategory: this.categorySelected,
          },
          this.config
        )
        .then((response) => {
          this.subcategories = response.data.subcategorias;
        })
        .catch((error) => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },
    fetchQuestions() {
      this.axios
        .post(
          "../apidev/levantamientos/getFichaPreguntas",
          {
            id_cat_principal: this.levantamientoInfo.id_cat_principal,
            id_cat_secundaria: this.levantamientoInfo.id_cat_secundaria,
          },
          this.config
        )
        .then((response) => {
          console.log(response);
          this.questions = response.data.questions;
        })
        .catch((error) => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },
    fetchAnswers() {
      console.log("fetchAnswers");
      this.axios
        .post(
          "../apidev/levantamientos/getFichaRespuestasJson",
          {
            id_levantamiento: this.levantamientoInfo.id,
          },
          this.config
        )
        .then((response) => {
          console.log(response);
          this.currentQuestions = response.data.answers;
        })
        .catch((error) => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },

    showMultimediaForm() {
      if (this.showCategoriesView) {
        const form = document.getElementById("levantamientoForm");
        const formData = new FormData(form);
        const validForm = this.validateForm(formData);

        if (validForm) {
          this.showCategoriesView = false;
          this.showFormView = false;
          this.showMultimediaView = true;
        }
      } else {
        this.showCategoriesView = false;
        this.showFormView = false;
        this.showMultimediaView = true;
      }
    },
    showLevantamientoForm() {
      if (this.showCategoriesView) {
        const form = document.getElementById("levantamientoForm");
        const formData = new FormData(form);
        const validForm = this.validateForm(formData);

        if (validForm) {
          this.showCategoriesView = false;
          this.showMultimediaView = false;
          this.showFormView = true;
        }
      } else {
        this.showCategoriesView = false;
        this.showMultimediaView = false;
        this.showFormView = true;
      }
    },
    saveLevantamiento() {
      let request = {};
      if (this.answers.length > 0) {
        let userAnswers = [];
        this.questions.forEach((question, index) => {
          let userAnswer = {
            id: question.id_pregunta,
            answer: this.answers[index],
          };

          userAnswers.push(userAnswer);
        });

        request = {
          id_cat_principal: this.categorySelected,
          id_cat_secundaria: this.subcategorySelected,
          id_usuario: localStorage.getItem("user_id"),
          nombre: this.nameLevantamiento,
          registro: null,
          respuestas: userAnswers,
          multimedia: null,
          fecha_levantamiento: new Date(),
          geometry: {},
          fuente: "web",
          latitud: this.latitud,
          longitud: this.longitud,
        };
      } else {
        request = {
          id_cat_principal: this.categorySelected,
          id_cat_secundaria: this.subcategorySelected,
          id_usuario: localStorage.getItem("user_id"),
          nombre: this.nameLevantamiento,
          registro: null,
          respuestas: null,
          multimedia: null,
          fecha_levantamiento: new Date(),
          geometry: {},
          fuente: "web",
          latitud: this.latitud,
          longitud: this.longitud,
        };
      }

      this.axios
        .post("../apidev/levantamientos/newLevantamiento", request, this.config)
        .then((response) => {
          if (document.getElementById("levantamientoFile").value !== "") {
            const form = document.getElementById("levantamientoForm");
            const formMediaData = new FormData(form);
            const levantamientoFile = formMediaData.get("levantamientoFile");
            // const mediaFilename =
            //   localStorage.getItem("user_id") + "_" + this.inputFilePlaceholder;
            const newDate = new Date();
            const mediaFilename =
              localStorage.getItem("user_id") +
              "_" +
              newDate.getTime() +
              this.fileMimeType;

            let levantamientoId = response.data.levantamiento_id;

            const formData = new FormData();
            formData.append("id", levantamientoId);
            formData.append(
              "levantamientoFile",
              levantamientoFile,
              mediaFilename
            );

            this.axios
              .post("../apidev/levantamientos/media", formData, this.config)
              .then((response) => {
                console.log(response);
                this.showingSuccess = true;
              })
              .catch((error) => {
                if (
                  error.response.status == 400 ||
                  error.response.status == 401
                ) {
                  if (
                    error.response.data.name === "TokenExpiredError" ||
                    error.response.data.name === "InvalidTokenError" ||
                    error.response.data.name === "JsonWebTokenError"
                  ) {
                    this.$router.push({ path: "/login" });
                  }
                }
              });
          } else {
            this.showingSuccess = true;
          }
        })
        .catch((error) => {
          console.log(error);
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },
    joinCategories(opciones) {
      let string_categories = "";
      for (const property in opciones) {
        if (opciones[property]) {
          string_categories += property + ", ";
        }
      }

      return string_categories;
    },
    backView() {
      this.showFormView = false;
      this.showMultimediaView = false;
      this.showCategoriesView = true;
    },
    validateForm(data) {
      if (data.get("selectCategory") === null) {
        this.errors.selectCategory = true;
      } else {
        this.errors.selectCategory = false;
      }

      if (data.get("selectSubcategory") === null) {
        this.errors.selectSubcategory = true;
      } else {
        this.errors.selectSubcategory = false;
      }

      if (data.get("name") === "") {
        this.errors.name = true;
      } else {
        this.errors.name = false;
      }

      if (
        this.errors.selectCategory ||
        this.errors.selectSubcategory ||
        this.errors.name
      ) {
        return false;
      }

      return true;
    },
    replaceURL() {
      return `http://miapptsil.miatsil.org.mx/compartir/${btoa(this.levantamientoInfo.id)}`
    },
    changeLevantamientoFile(event) {
      const file = event.target.files[0];
      this.inputFilePlaceholder = file.name;
      const fileMimeType = this.checkMimeType(file);

      if (fileMimeType === "") {
        this.errors.file_extension = true;
        this.levantamientoMediaUrl = this.srcUrl + "/null";
      } else {
        if (fileMimeType === ".mp4") {
          this.errors.file_extension = false;
          this.levantamientoVideoUrl = URL.createObjectURL(file);
          this.videoSelected = true;
          this.imageSelected = false;
        } else {
          let image = new Image();
          image.src = URL.createObjectURL(file);
          image.onload = () => {
            this.errors.file_extension = false;
            this.levantamientoImageUrl = URL.createObjectURL(file);
            this.imageSelected = true;
            this.videoSelected = false;
          };
        }
      }
      this.fileMimeType = fileMimeType;
    },
    checkMimeType(file) {
      let mimeType = "";
      switch (file.type) {
        case "image/jpeg":
          mimeType = ".jpeg";
          break;
        case "image/png":
          mimeType = ".png";
          break;
        case "image/jpg":
          mimeType = ".jpg";
          break;
        case "video/mp4":
          mimeType = ".mp4";
          break;
        default:
          mimeType = "";
          break;
      }
      return mimeType;
    },
    slideToLeft() {
      if (this.currentMediaIndex > 0) {
        this.currentMediaIndex -= 1;
      } else {
        this.currentMediaIndex = this.mediaArray.length - 1;
      }
      let nextMedia = this.mediaArray[this.currentMediaIndex];

      if (nextMedia.mimeType.includes("image")) {
        let image = document.getElementById("imageLev");
        image.src = `../apidev/${nextMedia.fileName}`;
      } else {
        let video = document.getElementById("videoLev");
        video.src = `../apidev/${nextMedia.fileName}`;
      }
    },
    slideToRight() {
      if (this.currentMediaIndex < this.mediaArray.length - 1) {
        this.currentMediaIndex += 1;
      } else {
        this.currentMediaIndex = 0;
      }
      let nextMedia = this.mediaArray[this.currentMediaIndex];

      if (nextMedia.mimeType.includes("image")) {
        let image = document.getElementById("imageLev");
        image.src = `../apidev/${nextMedia.fileName}`;
      } else {
        let video = document.getElementById("videoLev");
        video.src = `../apidev/${nextMedia.fileName}`;
      }
    },
  },
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
textarea {
  resize: none;
}

.textareaficha {
  resize: vertical; 
  text-align:justify; 
  height:auto;
}
</style>
